import { Button } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import { useNewChat } from '../hooks/useNewChat';

interface NewChatButtonProps {
	size?: 'xs' | 'sm' | 'md' | 'lg';
	variant?: 'solid' | 'ghost' | 'outline';
}

/**
 * Reusable "Start new chat" button component
 * Can be used in any header/toolbar within the Fusion Copilot interface
 */
export const NewChatButton = ({ size = 'sm', variant = 'solid' }: NewChatButtonProps) => {
	const { handleNewChat, isResetting, canStartNewChat } = useNewChat();

	if (!canStartNewChat) {
		return null;
	}

	return (
		<Button
			leftIcon={<AddIcon />}
			onClick={(e) => {
				e.stopPropagation();
				handleNewChat();
			}}
			isLoading={isResetting}
			size={size}
			variant={variant}
			colorScheme="orange"
			title="Start new chat"
		>
			New chat
		</Button>
	);
};
